class Charger {
  constructor(obj) {
    Object.assign(this, obj);
    obj["coordinates"] = obj.geometry.coordinates;
  }
}

export default Charger;
